import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ConnectivityBanner } from '../common/ConnectivityBanner';

export function Layout({ children, footer }: { children: React.ReactNode, footer?: React.ReactNode }) {
  return (
    <>
      <ConnectivityBanner />
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[10000] focus:bg-brand-cyan focus:text-black focus:px-4 focus:py-2 focus:rounded-lg focus:font-bold"
      >
        Pular para o conteúdo principal
      </a>
      <Navbar />
      <div id="main-content">
        {children}
      </div>
      {footer || <Footer />}
    </>
  );
}
